import Vue from 'vue';

var animationTimeout = function animationTimeout(iteration, duration, cb) {

	var start = performance.now();

	var animate = function animate(time) {

		var timePassed = time - start,
		    perc = duration / 100,
		    progress = Math.floor(timePassed / perc);

		if (timePassed < 0) timePassed = 0;
		if (timePassed > duration) timePassed = duration;

		if (progress < 0) progress = 0;
		if (progress > 100) progress = 100;

		iteration(progress);

		if (timePassed < duration) {
			requestAnimationFrame(animate);
		} else {
			if (cb) setTimeout(cb, 500);
		}
	};

	requestAnimationFrame(animate);
};

var scrollToElement = function scrollToElement(el, duration) {

	console.log(document.querySelector(el));

	if (typeof el === 'string') el = document.querySelector(el);
	if (!el) el = document.documentElement;

	duration = duration || 800;

	var curPos = window.pageYOffset,
	    tarPos = el.offsetTop - 60,
	    pos = tarPos - curPos;

	document.documentElement.classList.add('is-scrolling');

	animationTimeout(function (progress) {

		var stepPos = pos / 100 * progress + curPos;
		window.scrollTo(0, stepPos);
	}, duration, function () {
		document.documentElement.classList.remove('is-scrolling');
	});
};

Vue.directive('scroll-to', {
	inserted: function inserted(el, _ref) {
		var value = _ref.value;

		value = value || {};

		el.addEventListener('click', function (e) {
			e.preventDefault();
			scrollToElement(value.target, value.duration);
		});
	}
});

Vue.use({
	install: function install(Vue) {
		Vue.scrollTo = scrollToElement;
		Vue.prototype.$scrollTo = scrollToElement;
	}
});


//////////////////
// WEBPACK FOOTER
// ./directives/scroll-to.js
// module id = ./directives/scroll-to.js
// module chunks = 5